import {html} from '@isceco/widget-library2/external/lit'
import '@isceco/widget-library2/basic-elements/VerticalNavigation/VerticalNavigation.js'
import WebComponent from '../../../WebComponent.js'
import Navigation from '../../Navigation/Navigation.js'
import AuthorizationFilter from '../../Authorization/AuthorizationFilter.js'
import Authorization from '../../Authorization/Authorization.js'

export default class MassnahmenNavigation extends WebComponent {

  constructor() {
    super();
  }

  get translationFile() {
    return './views/Verbrauch/Navigation/i18n.json'
  }

  connectedCallback() {
    super.connectedCallback()
    this.navigationListener = _ => this.reload();
    document.addEventListener(Navigation.NAVIGATION_HAPPEND, this.navigationListener)
    this.render()
  }

  disconnectedCallback() {
    document.removeEventListener(Navigation.NAVIGATION_HAPPEND, this.navigationListener)
  }

  getTemplate() {
    const allItems = {
      Massnahmen_Chot: {
        text: this.i18n.translate('navigation.vertical.chot'),
        url: 'Massnahmen_Chot'
      },
      Massnahmen_Dch: {
        text: this.i18n.translate('navigation.vertical.dch'),
        url: 'Massnahmen_Dch'
      },
      Massnahmen_Gaznat: {
        text: this.i18n.translate('navigation.vertical.gaznat'),
        url: 'Massnahmen_Gaznat'
      },
      Massnahmen_Ail: {
        text: this.i18n.translate('navigation.vertical.ail'),
        url: 'Massnahmen_Ail'
      }
    }
    const items = getNavigationHash() === Authorization.VIEWS().notAuthorized ? null : AuthorizationFilter.viewsAllowed(Object.keys(allItems)).map(key => allItems[key])
    if (items === null) {
      return html``
    }

    return html`
            <isceco-vertical-navigation
                    .items="${items}">
            </isceco-vertical-navigation>
        `
  }
}
customElements.define('gasmonitoring-frontend-massnahmen-navigation', MassnahmenNavigation)
